import { render } from "./wImage.vue?vue&type=template&id=4b2a7156&ts=true"
import script from "./wImage.vue?vue&type=script&lang=ts"
export * from "./wImage.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__